import {
	IPlotData as ICorePlotData, createPlotData as createCorePlotData,
	ISourceData as ICoreSourceData, createData as createCoreData, addDataFactory, addSet
} from "models/core";
import { IDashboardViewModel } from "./core";

/**
 * Plot data source
 */
export type IPlotData = ICorePlotData;

/**
 * Source data
 */
export type ISourceData = ICoreSourceData;

/**
 * Raw data source. Used to shape and accumulate.
 */
export interface ISourceBuilder {
	uniques: Set<string>;
	values: ISourceData;
}

/**
 * Create a new plot data object.
 */
export const createPlotData = createCorePlotData;

/**
 * Create a new source data object
 */
export function createBuilder(): ISourceBuilder {
	return {
		uniques: new Set(),
		values: createCoreData(),
	};
}

const add = addDataFactory((vm: IDashboardViewModel) => vm.morphology.name);

/**
 * Returns the number added to the hierarchy on add, 0 otherwise. 
 * @param vm 
 * @param into 
 */
export function addData(vm: IDashboardViewModel, into: ISourceBuilder): number {
	//Only count once per diagnosis per morphology.
	if (!vm?.morphology?.id || !vm?.diagnosisId)
		return 0;

	if (addSet(vm.morphology.id + "_" + vm.diagnosisId, into.uniques)) {
		add(vm, into.values);
		return 1;
	}

	return 0;
}

/**
 * Compare sourceData[a] to sourceData[b] and return -1 when a is less than b, 0 when equal, 1 when a is greater than 0
 * @param a 
 * @param b 
 */
export const sort = (s: ISourceData, a: string, b: string): number => {
	return ((s[a] < s[b]) ? -1 : ((s[a] > s[b]) ? 1 : 0));
};

/** 
 * Complete adding data and clear any temporary resources 
 */
export function finish(builder: ISourceBuilder): ISourceData {
	try {
		return builder.values;
	} finally {
		builder.uniques.clear();
		builder.uniques = null;
		builder.values = null;
		builder = null;
	}
}